<div class="transactions-page-container p-4 d-flex flex-column gap-4">
  <div class="transactions-container card">
    <app-page-title
      class="border-bottom"
      iconClass="ic-inbox-20"
      header="Edge Transactions"
    >
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        (click)="refreshTransactionsGrid()"
      >
        <i class="icon ic-refresh-20"></i>
        <span>Refresh</span>
      </button>
    </app-page-title>

    <app-grid-server-side
      storageKey="edge-transactions"
      pageTitle="Transactions"
      [serverSideDatasource]="dataSource"
      [colDefs]="$any(colDefs)"
      [rowSelection]="rowSelection"
      [loading]="loading()"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="false"
      [getRowId]="getRowId"
      [hideSearch]="true"
      (gridReady)="onGridReady($event)"
    />
  </div>

  <div class="connections-container card">
    <app-page-title
      class="border-bottom"
      iconClass="ic-log-out-20"
      header="Connections"
    >
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        (click)="triggerOrganisationSignal()"
      >
        <i class="icon ic-external-link-20"></i>
        <span>Trigger Organisation Signal</span>
      </button>

      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-2"
        (click)="refreshConnectionsGrid()"
      >
        <i class="icon ic-refresh-20"></i>
        <span>Refresh</span>
      </button>
    </app-page-title>

    <app-grid-server-side
      storageKey="edge-connections"
      pageTitle="Connections"
      [serverSideDatasource]="connectionsDataSource"
      [colDefs]="$any(connectionsColDefs)"
      [rowSelection]="rowSelection"
      [loading]="loading()"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="false"
      [getRowId]="connectionsGetRowId"
      [hideSearch]="true"
      (gridReady)="onConnectionsGridReady($event)"
    />
  </div>
</div>

<app-edge-transaction-details
  [opened]="!!$selectedTransactionRecord()"
  [transactionRecord]="$selectedTransactionRecord()"
  (close)="onCloseDetails()"
  (refreshData)="refreshAll()"
/>
